import React, { useState } from 'react'
import './Staking.css'
import axios from 'axios';
import encyption from '../../Utils/encrypt';
import { errorPopup, successPopup } from '../../Utils/ToasterMessage';
import ButtonLoader from '../../Utils/Loader/ButtonLoader';

export default function StakingFetch() {
    const [userAddress, setUserAddress] = useState('');
    const [buttonLoader, setButtonLoader] = useState(false);

    const handleFetchStake = async () => {
        const validAddressRegex = /^(0x)?[0-9a-fA-F]{40}$/;
        setButtonLoader(true);

        if (!userAddress) {
            errorPopup('Please fill the address first!')
            setButtonLoader(false);
            return;
        } else if (!userAddress.match(validAddressRegex)) {
            errorPopup("Wallet address is not correct!");
            setButtonLoader(false);
            return;
        }

        try {
            await axios.post(
                'https://prod-backend.magnummeta.xyz/v1/stacking/saveStacking',
                {},
                {
                    headers: {
                        "mforge-api-key": encyption(
                            userAddress,
                            '0TIWSOPVU5KAQ7GX3N2L4Y81BHJZE9FR',
                            '4'
                        ),
                    },
                }
            ).then((res) => {
                setButtonLoader(false);
                setUserAddress('')
                successPopup('Stake Data fetch successfully')
            }).catch((err) => {
                setButtonLoader(false);
                setUserAddress('')
                errorPopup('There are some issue in fetching stake data')
                console.error(err);
            })
        } catch (error) {
            setButtonLoader(false);
            setUserAddress('')
            errorPopup('There are some issue in fetching stake data')
            console.error(error);
        }
    }

    return (
        <>
            <section className='stakign-fetch-cont'>
                <div className='sfc-sec-cont'>
                    <div className='fetch-stake-head'>Fetch Stake Manual</div>

                    <div className='sfc-input-cont'>
                        <div className='sfcic-sec'>
                            <input type="text" placeholder='Enter the address' value={userAddress} onChange={(e) => setUserAddress(e.target.value)} />
                        </div>

                        <button className='sfc-btn' onClick={handleFetchStake}>{buttonLoader ? <ButtonLoader /> : 'Fetch'}</button>
                    </div>
                </div>
            </section>
        </>
    )
}

